// extracted by mini-css-extract-plugin
export var buttons = "_bi-0";
export var buttonsActive = "_bi-h";
export var cancelConfirm = "_bi-1";
export var closeButton = "_bi-2";
export var column = "_bi-3";
export var container = "_bi-4";
export var detailHeader = "_bi-6";
export var detailTitle = "_bi-7";
export var detailsContent = "_bi-5";
export var header = "_bi-8";
export var headerWithClose = "_bi-9";
export var icon = "_bi-a";
export var infoIcon = "_bi-c";
export var informationContainer = "_bi-b";
export var sideDrawer = "_bi-d";
export var sideDrawerOpen = "_bi-e";
export var stickyFooter = "_bi-f";
export var typeOption = "_bi-g";